<template>
  <div class="weather-report">
    <el-dialog
      title="天气专报"
      v-dialogDrag
      :modal="false"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :modal-append-to-body=false
      :visible.sync="params.flag"
      ref="newWeaRef"
      :before-close="() => params.flag && $parent.toggleProductView('NewWeatherReport')">
      <div class="search">
        <div class="keywords">
          <i></i><input v-model="keywords" placeholder="请输入概况内容关键字" />
        </div>
        <div class="search-btn">
          <button @click="searchbtnClcik">搜索</button>
        </div>
      </div>
      <div class="table-data" >
       <div class="table1">
        <el-table :data="tableData" height="100%" style="width: 100%; ">
          <el-table-column prop="issuetime" label="发布时间" :width="rootFontSize * 10">
            <template slot-scope="scope">
              {{ scope.row.crttimeFmt&& scope.row.crttimeFmt.slice(0,-3)}}
            </template>
          </el-table-column>
          <el-table-column prop="subtitle" label="专报类型" :width="rootFontSize * 10"></el-table-column>
          <el-table-column prop="gaikuang" label="概况内容"></el-table-column>
          <el-table-column fixed="right" label="操作" :width="rootFontSize * 10">
            <template slot-scope="scope">
              <i @click="showMoreDetail(scope.row)" class="el-icon-more" title="更多"></i>
              <span
               class="el-icon-download"
              @click="pdfDownload(scope.row)">
              <a ref="aref"></a>
              </span>
            </template>
          </el-table-column>

        </el-table>
        </div>
      </div>
    </el-dialog>

    <more-detail
      ref="dtRed"
      title="天气专报详情"
      width="50%"
      :detailDialogVisible="detailDialogVisible"
      :morDetailConfig="morDetailConfig"
      :detailData="detailData" @changeDialogVisible="detailDialogVisible = false">
    </more-detail>
  </div>
</template>
<script>
import MoreDetail from './module/MoreDetail.vue'
import { handleDownload } from '@/utils/exportFile'
import { getFile } from '@/utils/pdf-download'
import { mapState } from 'vuex'
export default {
  props: ['params'],
  data () {
    return {
      keywords: '',
      tableData: [],
      rootFontSize: this.$rootFontSize,
      detailDialogVisible: false,
      detailData: {},
      morDetailConfig: [
        { label: '专报标题', field: 'subtitle' },
        { label: '一、', field: 'gaikuangTitle' },
        { label: '', field: 'gaikuang' },
        { label: '二、', field: 'influenceTitle' },
        { label: '', field: 'influence' },
        { label: '三、', field: 'suggestTitle' },
        { label: '', field: 'suggest' }
      ],
      tableHeight: 10
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('home', ['newestZhuanBao'])
  },
  mounted () {
    this.totalTable = this.newestZhuanBao
    this.tableData = this.newestZhuanBao
  },
  methods: {
    searchbtnClcik () {
      this.tableData = []
      this.totalTable.forEach(item => {
        if (item.subtitle.includes(this.keywords)) {
          this.tableData.push(item)
        }
      })
      this.keywords = ''
    },
    showMoreDetail (data) {
      console.log(this.$refs.dtRed)
      this.detailData = data
      this.detailDialogVisible = true
      this.$nextTick(() => {
        this.$refs.dtRed.setZindex()
      })
    },
    downloadClcik (data) {
      const fields = []
      const header = []
      this.morDetailConfig.forEach(item => {
        header.push(item.label)
        fields.push(item.field)
      })
      handleDownload(fields, [data], header, '天气专报')
    },

    pdfDownload (data) {
      const url = `${process.env.VUE_APP_DATA}/zhuanbao/${data.year}/pdf/${data.filepath}.pdf`
      const options = { title: '天气专报', fileType: 'application/pdf' }
      getFile(url, options, this.$refs.aref)
    },
    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.newWeaRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  },
  components: {
    MoreDetail
  }
}
</script>
<style lang="less" scoped>
.weather-report {
  pointer-events: none;
  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .datetime {
      label {
        font-size: 1rem;
        font-weight: 600;
        color: #333333;
      }
      /deep/.el-range-editor.el-input__inner {
        height: 2.5rem;
        line-height: 2.5rem;
        width: 25rem;
        .el-range__icon {
          line-height: 2.5rem;
          height: 2.5rem;
        }
        .el-range-separator {
          line-height: 2.5rem;
          height: 2.5rem;
          font-size: 1rem;
        }
        .el-range-input {
          font-size: 0.88rem;
          color: #FFF;
        }
      }
    }
    .keywords {
      width: 30rem;
      height: 2.5rem;
      border-radius: 0.38rem;
      border: 1px solid #52607F;
      display: flex;
      align-items: center;
       background: #0C4170;
      i {
        display: inline-block;
        width: 1.13rem;
        height: 1.06rem;
        background: url("../assets/images/搜索.png") no-repeat;
        background-size: contain;
        margin: 0 0.44rem 0 1rem;
      }
      input {
        height: 2.5rem;
        flex: 1;
        border-radius: 0.38rem;
        border: 0;
        font-size: 0.88rem;
        color: #FFF;
        outline: none;
        padding: 0 1rem 0 0;
        background: #0C4170;
    }
    input::placeholder{
      color: #FFF;
    }
    }
    .search-btn {
      button {
        width: 4.31rem;
        height: 2.44rem;
        background: linear-gradient(204deg, #59acfb 0%, #2d74f5 100%);
        border-radius: 0.38rem;
        border: 0;
        cursor: pointer;
        font-size: 0.88rem;
        color: #ffffff;
      }
    }
  }
  .table-data {
    margin: 1.19rem 0;
    // height: 31vh;
    flex: 1;
    position: relative;
    .table1{
      position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
    .el-table {
      background: transparent;
      text-align: center;

      /deep/ tr {
        background: transparent;
        th {
          text-align: center;
          border: 0;
          font-size: 0.88rem;
          font-weight: 600;
          color: #FFF;
          background: #0C4170;
        }
        td {
          text-align: center;
          font-size: 0.88rem;
          font-weight: 400;
          color: #FFF;
          border-bottom: 1px solid #316EA3;
        }
        .print {
          width: 1.13rem;
          height: 1.13rem;
          background: url("../assets/images/打印.png") no-repeat;
          border: 0;
          cursor: pointer;
          background-size: 1.13rem 1.13rem;
        }
        .image{
          margin: 0.52vw;
          width: 1.09vw;
          cursor: pointer;
        }
      }
      /deep/ tr:hover td{
          background: #0C4170 !important;
      }

      .new{
        margin-left: 0.52vw;
        background-color: #f56c6c;
        border-radius: 0.32vw;
         color: #fff;
         display: inline-block;
         font-size: 0.43vw;
         height: 0.94vw;
         line-height: 0.94vw;
         padding: 0.1vw 0.31vw;
         text-align: center;
         white-space: nowrap;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #273458;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #1b2230;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #0C4170;
      }
      /deep/.el-table__fixed-right-patch {
        background: #1F2C49;
        border: 0;
      }
    }
    .el-table::before,
    /deep/.el-table__fixed-right::before {
      background: transparent;
    }
  }
  .charts {
    flex: 1;
    display: flex;
    .chart-item {
      width: 50%;
      display: flex;
      flex-direction: column;
      .title {
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      .chart-wrap {
        flex: 1;
        position: relative;
        #month-chart {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }
        #year-chart {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }
      }
    }
  }
  /deep/.el-dialog__wrapper {
    overflow: hidden;
    .el-dialog {
      pointer-events: auto;
    }
  }
}
.el-icon-more,
.el-icon-download {
  margin: 0.52vw;
  color: blue;
  font-size: 0.94vw;
  cursor: pointer;
}
</style>
